// extracted by mini-css-extract-plugin
export default {"noHover":"TooltipInfoIcon_noHover__nmBQB"};